import { render, staticRenderFns } from "./p-packages-drafts-list.vue?vue&type=template&id=34930eed&scoped=true"
import script from "./p-packages-drafts-list.vue?vue&type=script&lang=js"
export * from "./p-packages-drafts-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34930eed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34930eed')) {
      api.createRecord('34930eed', component.options)
    } else {
      api.reload('34930eed', component.options)
    }
    module.hot.accept("./p-packages-drafts-list.vue?vue&type=template&id=34930eed&scoped=true", function () {
      api.rerender('34930eed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mpackages/views/p-packages-drafts-list.vue"
export default component.exports